import React, { useState, useEffect, useRef } from "react";
import { speakerIcon, graySpeakerOff } from "./images";

export const AudioPlayer = ({
  name,
  fileName,
  breaks,
  volume,
  isColorPink,
  isMuted,
  setIsMuted,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentVolume, setCurrentVolume] = useState(volume / 100);

  const audioRef = useRef(new Audio(fileName));
  const audio = audioRef.current;
  const isPlayingRef = useRef(isPlaying);
  const timerRef = useRef(null);

  const backgroundColor = isColorPink ? "#3F1627" : "#052617";

  // Keep ref in sync with state
  useEffect(() => {
    isPlayingRef.current = isPlaying;
  }, [isPlaying]);

  useEffect(() => {
    audio.volume = currentVolume;
  }, [currentVolume, audio]);

  useEffect(() => {
    function playAudioWithBreaks() {
      if (!isPlayingRef.current) {
        return;
      }
      
      audio
        .play()
        .then(() => {
          const breakTime = Number(breaks) || 0;
          timerRef.current = setTimeout(() => {
            if (isPlayingRef.current) {
              playAudioWithBreaks();
            }
          }, breakTime);
        })
        .catch((error) => {
          console.error("Audio play error:", error);
        });
    }

    if (isPlaying) {
      playAudioWithBreaks();
    } else {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      audio.pause();
      audio.currentTime = 0;
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      audio.pause();
      audio.currentTime = 0;
    };
  }, [isPlaying, audio, breaks]);

  const handleVolumeChange = (e) => {
    const volumeValue = e.target.value;
    setCurrentVolume(volumeValue);
    audio.volume = volumeValue;
  };

  const onSpeakerButtonClick = () => {
    const newPlayingState = !isPlaying;
    setIsPlaying(newPlayingState);
  };

  useEffect(() => {
    if (isMuted) {
      setIsPlaying(false);
    }
  }, [isMuted]);

  return (
    <div className="audio-player-container">
      <span className="audio-name">{name}</span>
      <div className="audio-controls">
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          className={isColorPink ? "custom-range-pink" : "custom-range"}
          value={currentVolume}
          onChange={handleVolumeChange}
          style={{
            background: `linear-gradient(to right, ${backgroundColor} ${
              currentVolume * 100
            }%, #000000 ${currentVolume * 100}%)`,
          }}
        />
        <img
          onClick={onSpeakerButtonClick}
          className="gray-speaker"
          src={isPlaying ? speakerIcon : graySpeakerOff}
          alt="speaker"
        />
      </div>
    </div>
  );
};
